/**
 * Newest-first sorting for records shown in menus (visits, PTPs, photos,
 * voice notes). Same rules as the desktop menus: dates come as yyyy-mm-dd or
 * dd-mm-yyyy, times as "10:56 AM" or "09:30 pm" or 24-hour.
 */
export const toSortKey = (date?: string, time?: string): string => {
  let d = (date || '').trim();
  const dmy = d.match(/^(\d{2})-(\d{2})-(\d{4})/);
  if (dmy) d = `${dmy[3]}-${dmy[2]}-${dmy[1]}`;
  d = d.slice(0, 10);
  let hhmm = '00:00';
  const t = (time || '').trim().match(/^(\d{1,2}):(\d{2})\s*([AaPp][Mm])?/);
  if (t) {
    let h = parseInt(t[1], 10);
    const ap = t[3] ? t[3].toUpperCase() : '';
    if (ap === 'PM' && h < 12) h += 12;
    if (ap === 'AM' && h === 12) h = 0;
    hhmm = `${String(h).padStart(2, '0')}:${t[2]}`;
  }
  return `${d} ${hhmm}`;
};

export const newestFirst = <T,>(items: T[], key: (x: T) => string): T[] =>
  [...items].sort((a, b) => key(b).localeCompare(key(a)));
